import VilgramFileDto from "../../../../../../dto/VilagramFileDto"

export enum ActionType {
    FILE_SHOW = 'FILE_SHOW',
    FILE_SAVE = 'FILE_SAVE'

}

export interface ActionFileShow {
    type: ActionType.FILE_SHOW,
    data: VilgramFileDto | undefined
}

type Action = ActionFileShow

export default Action